import { render } from "./ProfilePreview.vue?vue&type=template&id=49af0bcb"
import script from "./ProfilePreview.vue?vue&type=script&lang=js"
export * from "./ProfilePreview.vue?vue&type=script&lang=js"

import "./ProfilePreview.vue?vue&type=style&index=0&id=49af0bcb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__